<!-- Loader -->
@if (loading) {
  <div class="absolute inset-x-0 bottom-0">
    <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
  </div>
}

@if (!loading) {
  @if (!visibleDesign && !visibleLive) {
    <div class="p-4 flex flex-row flex-wrap">{{ 'dbTables.noData' | transloco }}</div>
  }
  @if (visibleDesign || visibleLive) {
    <div>
      <mat-button-toggle-group [formControl]="viewMode">
        <mat-button-toggle value="DESIGN" [hidden]="!visibleDesign">Design</mat-button-toggle>
        <mat-button-toggle value="LIVE" [hidden]="!visibleLive">Live</mat-button-toggle>
        <mat-button-toggle value="COMPARE" [hidden]="!visibleCompare">Compare</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <div>
      <ng-container *ngTemplateOutlet="viewMode.value !== 'COMPARE' ? listTables : compareTables"></ng-container>
    </div>
  }
}

<ng-template #listTables>
  <div class="p-4 grid grid-flow-row grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 flex-wrap">
    @if (showView === 'DESIGN') {
      <single-database-table-view class="p-2 w-full" [table]="drawSqlTablesDesign" [compare]="false"></single-database-table-view>
      @for (derivedTable of drawDerivedSqlTablesDesign | keyvalue; track derivedTable) {
        <single-database-table-view class="p-2" [table]="derivedTable.value" [compare]="false"></single-database-table-view>
      }
    }
    @if (showView === 'LIVE') {
      <single-database-table-view class="p-2" [table]="drawSqlTablesLive" [compare]="false"></single-database-table-view>
      @for (derivedTable of drawDerivedSqlTablesLive | keyvalue; track derivedTable) {
        <single-database-table-view class="p-2" [table]="derivedTable.value" [compare]="false"></single-database-table-view>
      }
    }
  </div>
</ng-template>

<ng-template #compareTables>
  <div class="p-4 grid grid-flow-row grid-cols-2 flex-wrap">
    <single-database-table-view class="p-2 w-full" [table]="drawSqlTablesDesign" [compare]="true"></single-database-table-view>
    <single-database-table-view class="p-2 w-full" [table]="drawSqlTablesLive" [compare]="true"></single-database-table-view>
    @for (_key of derivedListNames; track _key) {
      @if (drawDerivedSqlTablesDesign.has(_key)) {
        <single-database-table-view class="flex p-2 w-full" [table]="drawDerivedSqlTablesDesign.get(_key)" [compare]="true"></single-database-table-view>
      }
      @if (drawDerivedSqlTablesLive.has(_key)) {
        <single-database-table-view class="flex p-2 w-full" [table]="drawDerivedSqlTablesLive.get(_key)" [compare]="true"></single-database-table-view>
      }
    }
  </div>
</ng-template>